<ng-container *ngIf="!!get">
    <tt-tabs *ngIf="!editKeyno" [(ttSelectedId)]="get.gb_docarticle_main">
        <tt-tab ttId="MAIN" ttLabel="gb_docarticle_main"></tt-tab>
        <tt-tab ttId="ADMIN" ttLabel="gb_docarticle_admin"></tt-tab>
    </tt-tabs>

    <tt-card [hidden]="get.gb_docarticle_main !== 'MAIN'" [ttHeading]="editKeyno === '0' ? '' : get.title" ttTranslateHeading="false">
        <div [hidden]="!!editKeyno">
            <tt-editor [ttModel]="get.html_content_base64" ttReadonly></tt-editor>

            <ng-container *ngIf="!('mobile' | mediaQuery)">
                <tt-button-goto *ngIf="get.sub_docarticle_admin === '1'" ttText="docarticle_edit" ttIcon="far fa-edit" (ttClick)="editKeyno = get.docarticle_keyno"></tt-button-goto>
                <tt-button-goto *ngIf="get.sub_docarticle_admin === '1'" ttText="docarticleedit_create" ttIcon="far fa-plus" (ttClick)="create()"></tt-button-goto>
            </ng-container>
            <ng-container *ngIf="'mobile' | mediaQuery">
                <tt-button-goto
                    *ngIf="get.sub_docarticle_admin === '1'"
                    ttText="docarticle_edit"
                    ttIcon="far fa-edit"
                    ttGoto="docarticleedit"
                    [ttGotoParms]="{ docarticle_keyno: get.docarticle_keyno }"
                ></tt-button-goto>
                <tt-button-goto *ngIf="get.sub_docarticle_admin === '1'" ttText="docarticleedit_create" ttIcon="far fa-plus" (ttClick)="gotoCreate()"></tt-button-goto>
            </ng-container>
        </div>
        <tt-doc-article-edit *ngIf="!!editKeyno" [params]="{ docarticle_keyno: editKeyno }" (submit)="onSubmit($event)"></tt-doc-article-edit>
    </tt-card>
    <tt-list *ngIf="'mobile' | mediaQuery" [hidden]="get.gb_docarticle_main !== 'MAIN'" [ttData]="relatedArticles"></tt-list>

    <tt-card [hidden]="get.gb_docarticle_main !== 'ADMIN'">
        <tt-datetime class="col-xs-12 col-md-5 sp-0" ttLabel="reg_date" [ttModel]="get.reg_date" ttReadonly></tt-datetime>
        <tt-input class="col-xs-12 col-md-7 sp-0" ttLabel="reg_portal_user_name" [ttModel]="get.reg_portal_user_name" ttReadonly></tt-input>
        <tt-datetime class="col-xs-12 col-md-5 sp-0" ttLabel="mod_date" [ttModel]="get.mod_date" ttReadonly></tt-datetime>
        <tt-input class="col-xs-12 col-md-7 sp-0" ttLabel="mod_portal_user_name" [ttModel]="get.mod_portal_user_name" ttReadonly></tt-input>
        <tt-button-goto
            *ngIf="get.sub_docarticle_admin === '1'"
            ttText="docarticleporus_goto"
            [ttBadge]="'' + get.nbr_of_read"
            ttGoto="docarticleporus"
            [ttGotoParms]="{ docarticle_keyno: get.docarticle_keyno }"
        ></tt-button-goto>
        <tt-button-goto ttText="docarticle_security" ttGoto="docarticletopusergroups" [ttGotoParms]="{ docarticle_keyno_top: get.docarticle_keyno_top }"></tt-button-goto>
    </tt-card>
</ng-container>

<!-- Skeleton/loading animation -->
<ng-container *ngIf="!get">
    <tt-tabs>
        <tt-tab ttId="skeleton1" [ttSkeleton]="true"></tt-tab>
        <tt-tab ttId="skeleton2" [ttSkeleton]="true"></tt-tab>
    </tt-tabs>
    <tt-card>
        <div class="col-xs-4 sp-0 tt-skeleton" style="height: var(--tt-height); width: 30%; margin-bottom: 7px"></div>
        <div class="col-xs-12 sp-0 tt-skeleton" style="height: 20rem; margin-bottom: 7px"></div>
        <div class="col-xs-12sp-2">
            <div class="col-xs-2 tt-skeleton" style="height: var(--tt-height); width: 20%; background-color: var(--tt-link-color); opacity: 0.2; margin-bottom: 7px"></div>
        </div>
        <div class="col-xs-12 sp-2">
            <div class="col-xs-2 tt-skeleton" style="height: var(--tt-height); width: 20%; background-color: var(--tt-link-color); opacity: 0.2; margin-bottom: 7px"></div>
        </div>
    </tt-card>
</ng-container>

<ng-template #inputskeleton>
    <div class="col-xs-4 sp-0 tt-skeleton" style="width: 40%; height: var(--tt-font-size-sm); margin-bottom: 4px"></div>
    <div class="col-xs-12 sp-0 tt-skeleton" style="height: var(--tt-height); margin-bottom: 7px"></div>
</ng-template>

<!-- <section class="docarcticle">
    <div class="row-fluid">
        <form class="form-horizontal sp-0" name="formDocArticle" novalidate method="get" role="form">
            <div class="well well-sm col-xs-12" ng-show="vm.model.edit.docarticle_keyno_top > 0">
                <div ng-if="vm.model.edit.page_heading > ''">
                    <label class="checklist-h1 col-xs-12" tt-header="{{vm.model.edit.page_heading}}"></label>
                </div>
                <div ng-show="vm.model.edit.sub_docarticle_admin === '1'">
                    <im-btn-group-directive list-items="vm.model.bgDocArticleMain.records" optionfunc="vm.selectBgDocArticleMain(item)" active-btn="vm.model.bgDocArticleMain.item_default" class="col-xs-12 sp-0"></im-btn-group-directive>
                </div>
                <div ng-show="vm.model.bgDocArticleMain.item_selected === 'MAIN'">
                    <tt-message tt-label="{{vm.model.edit.title}}" tt-label-view="top" tt-model="vm.model.edit.html_content_base64" tt-is-html="vm.model.isHtml" tt-translate="false"></tt-message>
                    <div ng-show="vm.model.edit.sub_docarticle_admin === '1'">
                        <im-button-directive name="docarticle_edit" badge="" optionfunc="vm.goTo('docarticleedit')" btnsize="col-xs-12 sp-0" glyphs="glyphicon-chevron-right pull-right"></im-button-directive>
                    </div>
                </div>
                <div ng-show="vm.model.edit.sub_docarticle_admin === '1'">
                    <im-button-directive name="docarticleedit_create" badge="" optionfunc="vm.createNew()" btnsize="col-xs-12 sp-0" glyphs="glyphicon-plus pull-right"></im-button-directive>
                </div>
            </div>
            <div ng-show="vm.model.bgDocArticleMain.item_selected === 'MAIN'">
                <im-list-directive list-items="vm.model.itemsListDocArticles" badge="" ltype="" design-var="s12"></im-list-directive>
            </div>
            <div class="well well-sm col-xs-12" ng-show="vm.model.edit.sub_docarticle_admin === '1' || vm.model.bgDocArticleMain.item_selected === 'ADMIN'">
                <div class="col-xs-12 sp-0">
                    <div ng-show="vm.model.edit.sub_docarticle_admin === '1' && vm.model.edit.docarticle_keyno_top === '0'">
                        <im-button-directive name="docarticleedit_create_new_book" badge="" optionfunc="vm.createNew()" btnsize="col-xs-12 sp-0" glyphs="glyphicon-plus pull-right"></im-button-directive>
                    </div>
                    <div ng-show="vm.model.bgDocArticleMain.item_selected === 'ADMIN'">
                        <im-input-directive label="reg_portal_user_name" field="vm.model.edit.reg_portal_user_name" placeholder="" type="input" typevar="r"></im-input-directive>
                        <im-input-directive label="reg_date" field="vm.model.edit.reg_date" type="datetime" typevar="drhrmr"></im-input-directive>
                        <im-input-directive label="mod_portal_user_name" field="vm.model.edit.mod_portal_user_name" placeholder="" type="input" typevar="r"></im-input-directive>
                        <im-input-directive label="mod_date" field="vm.model.edit.mod_date" type="datetime" typevar="drhrmr"></im-input-directive>
                        <div ng-show="vm.model.edit.sub_docarticle_admin === '1'">
                            <im-button-directive name="docarticleporus_goto" badge="vm.model.edit.nbr_of_read" optionfunc="vm.goTo('docarticleporus')" btnsize="col-xs-12 sp-0" glyphs="glyphicon-chevron-right pull-right"></im-button-directive>
                        </div>
                        <im-button-directive name="docarticle_security" badge="" optionfunc="vm.goTo('docarticletopusergroups')" btnsize="col-xs-12 sp-0" glyphs="glyphicon-chevron-right pull-right"></im-button-directive>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section> -->
